import React, { useState, useEffect } from 'react'
import { HiMenuAlt3, HiX } from 'react-icons/hi'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset'
  }, [isOpen])

  const navLinks = [
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' },
    { name: 'Homelab', href: '#homelab' },
    { name: 'Contact', href: '#contact' },
  ]

  return (
    <>
      <nav className={`fixed w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'py-4 bg-dark/80 backdrop-blur-xl border-b border-edge'
          : 'py-5 sm:py-6 bg-transparent'
      }`}>
        <div className="max-w-6xl mx-auto px-6 sm:px-8 flex justify-between items-center">
          <a
            href="#home"
            className="font-display font-extrabold text-xl sm:text-2xl text-cream tracking-tight hover:text-lime transition-colors duration-300"
          >
            SA<span className="text-lime">.</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm text-cream-dim hover:text-cream transition-colors duration-300 tracking-[0.15em] uppercase link-underline"
              >
                {link.name}
              </a>
            ))}
            <a
              href="mailto:sakariaahmed.code@gmail.com"
              className="text-sm text-dark bg-lime px-5 py-2.5 rounded-full hover:shadow-[0_0_20px_rgba(201,251,53,0.3)] transition-all duration-300 font-medium tracking-wide"
            >
              Say Hello
            </a>
          </div>

          <button
            onClick={() => setIsOpen(true)}
            className="md:hidden text-2xl text-cream hover:text-lime transition-colors p-2"
            aria-label="Open menu"
          >
            <HiMenuAlt3 />
          </button>
        </div>
      </nav>

      <div className={`md:hidden fixed inset-0 z-[55] bg-dark flex flex-col items-center justify-center transition-all duration-500 ${
        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
      }`}>
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-5 right-6 sm:top-6 sm:right-8 text-2xl text-cream hover:text-lime transition-colors p-2"
          aria-label="Close menu"
        >
          <HiX />
        </button>

        <div className="flex flex-col items-center gap-7 sm:gap-8">
          {[{ name: 'Home', href: '#home' }, ...navLinks].map((link, i) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className={`text-3xl sm:text-4xl font-display font-bold text-cream hover:text-lime transition-all duration-300 ${
                isOpen ? 'animate-slide-down' : ''
              }`}
              style={{ animationDelay: `${i * 75}ms` }}
            >
              {link.name}
            </a>
          ))}
          <a
            href="mailto:sakariaahmed.code@gmail.com"
            onClick={() => setIsOpen(false)}
            className="mt-4 px-8 py-3.5 text-lg bg-lime text-dark rounded-full font-medium hover:shadow-[0_0_30px_rgba(201,251,53,0.3)] transition-all duration-300"
          >
            Say Hello
          </a>
        </div>
      </div>
    </>
  )
}

export default Navbar
